<template>
  <main class="table-container" v-if="tasks.length">
    <table class="my-table">
      <thead class="my-thead">
        <tr>
          <th class="my-th" style="min-width: 120px">
            <p class="-stb">Reference</p>
          </th>
          <th class="my-th" style="width: 38%; min-width: 300px">
            <p class="-stb">Task Title</p>
          </th>
          <th class="my-th" style="min-width: 170px">
            <p class="-stb">Responsible</p>
          </th>
          <th class="my-th" style="min-width: 100px">
            <p class="-stb">Status</p>
          </th>
          <th class="my-th" style="min-width: 110px">
            <p class="-stb">DeadLine</p>
          </th>
          <th
            class="my-th"
            style="width: 4%"
            v-show="selectedStages.length > 1"
          >
            <p class="-stb">Stage</p>
          </th>
          <th class="my-th" style="width: 4%"></th>
          <th class="my-th" style="width: 4%"></th>
          <th class="my-th" style="width: 4%"></th>
        </tr>
      </thead>
      <tbody v-for="(task, index) in tasks" :key="task">
        <tr
          class="tr-content"
          :class="[index % 2 ? 'bg-primary' : 'bg-secondary']"
        >
          <td class="my-td">
            <p class="-stb">
              {{ getFrame[index].frame_stage_id - 1 }}.{{
                getReference(getTasksObj[index].id)
              }}
            </p>
          </td>
          <td class="my-td">
            <p class="-str">{{ getTasksObj[index].task_name }}</p>
          </td>
          <td class="my-td">
            <div class="flex-row" v-if="task.verComIsabela">
              <DynaBadge
                :picturePath="getUsers[index].picture"
                :first_name="getUsers[index].first_name"
                :last_name="getUsers[index].last_name"
              />
              <div class="flex-column">
                <p class="-stb">{{ getAgents[index].agent_name }}</p>
                <p class="-str">
                  {{ getUsers[index].first_name }}
                  {{ getUsers[index].last_name }}
                </p>
              </div>
            </div>
            <div class="flex-row" v-else-if="getAgents[index]">
              <DynaBadge />
              <div class="flex-column">
                <p class="-stb">{{ getAgents[index].agent_name }}</p>
                <p class="-str">No user assigned</p>
              </div>
            </div>
            <div class="flex-row" v-else>
              <DynaBadge />
              <div class="flex-column">
                <p class="-str">Nothing assigned</p>
              </div>
            </div>
          </td>
          <td class="my-td">
            <div
              class="status-container"
              :class="getStatusStyle(getStatus[index].progress_status_name)"
            >
              <p class="-xstb">{{ getStatus[index].progress_status_name }}</p>
            </div>
          </td>
          <td class="my-td">
            <p class="-str">{{ task.deadline }}</p>
          </td>
          <td
            class="my-td"
            style="max-width: 40px; padding-left: 30px"
            v-show="selectedStages.length > 1"
          >
            <p class="-stb">
              {{ getTaskStage(getFrame[index].frame_stage_id) }}
            </p>
          </td>
          <td class="my-td" style="max-width: 40px">
            <IconLink title="Link to Deliverable" />
          </td>
          <td class="my-td" style="max-width: 40px">
            <IconEdit title="Edit Row" @click="setModal('update', task)" />
          </td>
          <td class="my-td" style="max-width: 40px">
            <IconTrash @click="removeItem(task.id)" title="Delete Row" />
          </td>
        </tr>
      </tbody>
    </table>
  </main>
  <main class="no-data" v-else>
    <NoData :item="'task'" />
  </main>
</template>

<script>
import { mapGetters } from "vuex";
import IconTrash from "../../../assets/icons/dynamicIcons/IconTrash.vue";
import IconEdit from "../../../assets/icons/dynamicIcons/IconEdit.vue";
import IconLink from "../../../assets/icons/dynamicIcons/IconLink.vue";
import DynaBadge from "../../utils/DynaBadge.vue";
import NoData from "../../utils/NoData.vue";
import { getUnitTasks } from "../../../services/requests/get/tasks";
export default {
  components: { IconTrash, IconEdit, IconLink, DynaBadge, NoData },
  data() {
    return {
      onBehalf: false,
      tasks: [],
    };
  },
  methods: {
    removeItem(toRemove) {
      console.log(toRemove);
    },
    getStatusStyle(status) {
      const statusList = ["Ongoing", "Awaiting Verification", "Completed"];
      const filtered = statusList.filter((msg) => msg === status);

      return filtered.toString().replace(" ", "-").toLowerCase();
    },
    getTaskStage(frame_stage_id) {
      const stage = this.$store.state.stages.find(
        (stage) => stage.frame_stage_id == frame_stage_id
      );
      return stage.stage_value;
    },

    async getTasks(selectedStages) {
      console.log("GET TASKS RAN");
      if (selectedStages) {
        const res = await getUnitTasks(selectedStages, true);
        console.log("with selected stages: ", res);

        if (res.status != 200) return;

        this.tasks = res.data;
      } else {
        const stagesArray = [this.$store.state.selectedStages];
        const res = await getUnitTasks(stagesArray, true);
        console.log("without selected stages: ", res);

        if (res.status != 200) return;

        this.tasks = res.data;
      }
    },
    // will need mapGetters : user, selectedStages
    setModal(cmd, item) {
      this.$emit("setModal", cmd, item);
    },

    //delete this when backend is done
    getReference(n) {
      let numberAsString = n.toString();

      if (numberAsString.length < 3) {
        while (numberAsString.length < 3) {
          numberAsString = "0" + numberAsString;
        }
      }

      return numberAsString;
    },
  },
  computed: {
    ...mapGetters(["selectedStages"]),
    getUsers() {
      return this.tasks.map((task) => task.user);
    },
    getTasksObj() {
      return this.tasks.map((task) => task.task);
    },
    getStatus() {
      return this.tasks.map((task) => task.progress_status);
    },
    getAgents() {
      return this.tasks.map((task) => task.taskpers_agent);
    },
    getFrame() {
      //this should be temp - falar com Isabela
      return this.tasks.map((task) => task.frame);
    },
  },

  watch: {
    "$store.state.selectedStages": {
      handler: async function (newVal) {
        await this.getTasks(newVal);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.bg-primary {
  background: #f9fafb !important;
}
.bg-secondary {
  background: var(--white1) !important;
}
.table-container {
  width: 100%;
  height: auto;
}
.item-hover {
  cursor: pointer;
}
.my-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  transition: all 250ms ease;
}
.my-thead {
  /* background: var(--primary); */
  background-image: linear-gradient(
    to right,
    var(--primary) 0%,
    #004e92 51%,
    var(--primary) 100%
  );
  background-size: 500% auto;
}

.my-th {
  padding: 8px;
  color: var(--white1);
}
.my-th:first-child {
  border-top-left-radius: 8px;
}
.my-th:last-child {
  border-top-right-radius: 8px;
}
.my-td {
  padding: 8px;
}

/* .tr-content {
  transition: 100ms ease;
} */
.toggled-row {
  position: relative;
  box-shadow: 0px 8px 8px -6px rgba(0, 0, 0, 0.1);
  z-index: 1;
}
.tr-content:hover {
  background: rgb(243, 248, 254) !important;
}
.tr-toggled-content {
  /* border-block: 1px solid var(--gray5); */
  background: var(--gray6);
}
.tr-toggled-content:last-child {
  box-shadow: inset 0px -8px 8px -6px rgba(0, 0, 0, 0.1);
}
.flex-row {
  display: flex;
  gap: 4px;
  justify-content: flex-start;
  align-items: center;
}
.flex-column {
  display: flex;
  flex-direction: column;
}
.flex-column p:last-child {
  color: var(--gray2);
}

.toggled {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 64px;
  padding-inline: 12px;
}
.toggled-text {
  color: var(--gray2);
}
/*ICONS*/
i {
  transform: scale(0.5);
  cursor: pointer;
}

.rotate {
  transform: rotateZ(180deg) scale(0.5);
}

/*STATUS*/
.status-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  width: fit-content;
  padding-inline: 8px;
  padding-block: 4px;
  border-radius: 32px;
}
.completed {
  background: #e3ffef;
  color: #027a48;
}
.ongoing {
  background: #e0f6ff;
  color: #0044b9;
}
.awaiting-verification {
  white-space: nowrap;
  background: #f8edff;
  color: #c973ff;
}
thead {
  position: sticky;
  top: 0;
  z-index: 2;
}
</style>